module.exports = __webpack_public_path__ + "static/media/wall-insulation@2x.8ea4be65.jpg";